export { default as AboutUs } from "./AboutUs";
export { default as Features } from "./Features";
export { default as Home } from "./Home";
export { default as Pricing } from "./Pricing";
export { default as UseCase } from "./UseCase";
export { default as ContactUs } from "./ContactUs";


// WEBPACK FOOTER //
// ./src/containers/index.js